import { Component, Inject, OnInit } from '@angular/core';
import { FormBuilder, FormGroup, Validators } from '@angular/forms';
import { MatDialogRef, MAT_DIALOG_DATA } from '@angular/material/dialog';
import { Student } from '../model/student';
import { GetCollectionService } from '../services/get-collection.service';

@Component({
  selector: "app-create-student",
  templateUrl: "./create-student.component.html",
  styleUrls: ["./create-student.component.css"],
})
export class CreateStudentComponent implements OnInit {
  students: Student[];
  myForm: FormGroup;
  actionName:string;
  constructor(
    public dialogRef: MatDialogRef<CreateStudentComponent>,
    private crudService: GetCollectionService,
    private fb: FormBuilder,
    @Inject(MAT_DIALOG_DATA) public editData:any,
  ) {    
    this.myForm = this.fb.group({
      Name: ["", Validators.required],
      Age: ["", [Validators.required]],
      Gender: ["", [Validators.required]],
      Dateofbirth: ["", [Validators.required]],
      Sectionname: ["", [Validators.required]],
      Classname: ["", [Validators.required]],
      Religion: ["", [Validators.required]],
      Caste: ["", [Validators.required]],
      Mobile: ["", [Validators.required]],
      Admissionnum: ["", [Validators.required]],
      Fathername: ["", [Validators.required]],
      Fatheroccu: ["", [Validators.required]],
      Mothername: ["", [Validators.required]],
      Motheroccu: ["", [Validators.required]],
      Address: ["", [Validators.required, Validators.minLength(5)]],
    });
  } 

  ngOnInit(): void {    
    if(this.editData){     
      this.myForm.controls['Name'].setValue(this.editData.Name);
      this.myForm.controls['Age'].setValue(this.editData.Age);
      this.myForm.controls['Gender'].setValue(this.editData.Gender);
      this.myForm.controls['Address'].setValue(this.editData.Address);
      this.myForm.controls['Dateofbirth'].setValue(this.editData.Dateofbirth);
      this.myForm.controls['Classname'].setValue(this.editData.Classname);
      this.myForm.controls['Sectionname'].setValue(this.editData.Sectionname);
      this.myForm.controls['Religion'].setValue(this.editData.Religion);
      this.myForm.controls['Caste'].setValue(this.editData.Caste);
      this.myForm.controls['Mobile'].setValue(this.editData.Mobile);
      this.myForm.controls['Admissionnum'].setValue(this.editData.Admissionnum);
      this.myForm.controls['Fathername'].setValue(this.editData.Fathername);
      this.myForm.controls['Fatheroccu'].setValue(this.editData.Fatheroccu);
      this.myForm.controls['Mothername'].setValue(this.editData.Mothername);
      this.myForm.controls['Motheroccu'].setValue(this.editData.Motheroccu);
      this.actionName="Update";
    }
    else{
      this.actionName="Save";
    }
  }

  onNoClick(): void {
    //console.log("clicked");
    this.dialogRef.close();
  }

  onSubmit() { 
    if(this.editData){
      if (this.myForm.valid) {
        this.crudService.update_Student('Students',this.editData.id,this.myForm.value);
          this.myForm.reset();        
      }

    } else{
      if (this.myForm.valid) {    
        this.crudService.create_NewStudent('Students',this.myForm.value).then((resp) => {
          alert("Student Saved Successfully.")
          this.myForm.reset();
        },(err)=>{
          console.log(err);
        });
      }
    } 
    
  }
}
